export function mapRequestType(requestType: string): string {
    switch (requestType) {
        case "PRINT": {
            return "Print"
        }
        case "GENERATE": {
            return "Generate"
        }
        case "GENERATE_AND_PRINT": {
            return "Generate and Print"
        }
        case "GENERATE_AND_SAVE": {
            return "Generate and Save"
        }
        default: {
            return requestType
        }
    }
}